import keepital from './keepital';
import superRoute from './super';
import log from './log';

export default [...keepital, ...superRoute, ...log];
